const defaultState = [];
export default (state = defaultState, action) => {
    switch (action.type) {
        case 'GET_TDM_ROUTES_SUCCESS':
            return action.data.data;
        default:
            return state;
    }
};
